import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-indagini-preliminari-view',
  templateUrl: './form-indagini-preliminari-view.component.html',
  styleUrls: ['./form-indagini-preliminari-view.component.css']
})
export class FormIndaginiPreliminariViewComponent {
  @Input() labelCreatoDaSistema;

  @Input() ctxBodyFascicolo;
  constructor() {}
}
